import styled from "styled-components";

export const CashbackRowStyled = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 8px 0;

    &:not(:last-child) {
        border-bottom: 1px solid var(--color-divider-transparent);
    }
`;
